<template>
  <div>
    <!-- <button class="btn btn-sm btn-success" type="button" @click="nuevaCotizacionModel">
      <i class="fa fa-plus"></i>
      Crear desde Req de Compra
    </button> -->
    <button
      class="btn btn-sm btn-success"
      type="button"
      @click="nuevaCotizacion"
    >
      <i class="fa fa-plus"></i>
      Nueva Cotización
    </button>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="nuevaCotizacionModel"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            ref="cerrarModal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h4 class="onboarding-title text-center">
                  Nueva Cotización basada en Requerimiento de Compra
                </h4>
              </div>
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <!-------------------- Tabla de REsultados -------------------->
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Tienda</th>
                            <th>Usuario</th>
                            <th>Fecha Creacion</th>
                            <th>Fecha</th>
                            <th class="text-center">Estado</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="current in dataTabla.results"
                            v-bind:key="current.id"
                            @click="generar_cotizacion(current)"
                          >
                            <td>{{ current.numero }}</td>
                            <td>{{ current.tienda.nombre }}</td>
                            <td>
                              <UsuarioEnTablaComponent
                                :current="current.usuario"
                              />
                            </td>
                            <td>
                              <timeago
                                :title="current.fecha_creacion"
                                :datetime="current.fecha_creacion"
                              ></timeago>
                            </td>
                            <td>{{ current.fecha }}</td>
                            <td class="text-center">
                              <div
                                data-title="Activo"
                                data-toggle="tooltip"
                                v-html="current.estado_str"
                              ></div>
                            </td>
                            <td class="text-center"></td>
                          </tr>
                        </tbody>
                      </table>
                      <PaginationComponent
                        :currentPage="currentPage"
                        :data="dataTabla"
                        @pagechanged="onPageChange"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import TiendaService from "@/services/catalogos/TiendaService";
import ProveedorService from "@/services/catalogos/ProveedorService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqCompraService from "@/services/compras/ReqCompraService";
import Notifications from "@/notifications/notifications";
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      current: {
        id: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        reqcomprad_set: [],
      },
      tiendas: [],
      currentPage: 1,
      proveedores: [],
      dataTabla: {
        results: [],
        currentPage: 1,
      },
      productos: [],
      options: [],
    };
  },
  computed: {},
  mounted() {
    let self = this;
    TiendaService.fetch({
      activa: true,
      quitar_paginacion: true,
    }).then((res) => {
      self.tiendas = res.data;
    });
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshReqCompraPendientes(page);
    },
    refreshReqCompraPendientes(page) {
      let self = this;
      ReqCompraService.para_cotizar({
        page: page,
      }).then((res) => {
        self.dataTabla = res.data;
      });
    },

    nuevaCotizacion() {
      let self = this;
      self.$router.push({
        path: "/compras/cotizaciones/nueva",
      });
    },
    nuevaCotizacionModel() {
      let self = this;
      $("#nuevaCotizacionModel").modal("show");
      this.refreshReqCompraPendientes(1);
    },
    generar_cotizacion(current) {
      /**
       * Genera una cotización basada en el requerimiento de compra
       */
      let self = this;

      ReqCompraService.generar_cotizacion(current.id)
        .then((response) => {
          let id_cot = response.data.cotizacion_e;
          $("#nuevaCotizacionModel").modal("hide");

          Notifications.alert.confirm(
            "Cotización Generada",
            "Ir a la Cotizacion Generada",
            "",
            function () {
              self.$router.push({
                name: "compras-cotizaciones-editar",
                params: { id: id_cot },
              });
            }
          );
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
  },
};
</script>
